import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'atoms/Button/Button';
import ImageUserPlusSvg from 'images/v5/icons/image-user-plus.svg';
import PlusSvg from 'images/v5/icons/plus.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import FileInput from 'layout/atoms/FileInput/';
import styles from './Photo.module.scss';
function Photo({ alt, src, standalone = false, noMinHeight = false, size = 'm', theme = 'default', disabled = false, onPhotoAdd, onPhotoDelete, }) {
    const { t } = useTranslation('common');
    const isAvatar = theme === 'avatar';
    const classes = classNames(styles.wrap, styles[theme], styles[size], {
        [styles.noMinHeight]: noMinHeight,
        [styles.stadnalone]: standalone,
        [styles.disabled]: disabled,
    });
    if (!onPhotoAdd) {
        React.createElement("div", { className: styles.add });
    }
    if (disabled) {
        return React.createElement("div", { className: classes }, src && React.createElement("img", { src: src, alt: alt }));
    }
    return (React.createElement("div", { className: classes }, src ? (React.createElement(React.Fragment, null,
        React.createElement("img", { src: src, alt: alt }),
        onPhotoDelete && (React.createElement("div", { className: styles.delete },
            React.createElement(Button, { size: "xs", color: "danger", shape: "rounded", leftIcon: React.createElement(TrashSvg, null), onClick: onPhotoDelete }))))) : (React.createElement(FileInput, { allowedExtensions: ['jpg', 'png', 'jpeg'], allowMultipleFiles: true, onSelect: onPhotoAdd }, (openFileChooser) => isAvatar ? (React.createElement("button", { type: "button", className: styles.add, onClick: openFileChooser, "aria-label": t('add') },
        React.createElement(ImageUserPlusSvg, null))) : (React.createElement("div", { className: styles.add },
        React.createElement(Button, { shape: "squared", onClick: openFileChooser },
            React.createElement(PlusSvg, null))))))));
}
export default Photo;
